import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { Parameter } from './parameter.js'

export const VariableDefinitionContexts = {
	local: 'Local',
	input: 'Input',
	pathParam: 'URL Parameter',
} as const
export type VariableDefinitionContext = keyof typeof VariableDefinitionContexts

@jsonClass('VariableDefinition')
export class VariableDefinition extends Parameter {
	@jsonProperty(String) context!: VariableDefinitionContext
	@jsonProperty(Boolean) isStatic: boolean = false

	constructor(init?: Partial<VariableDefinition>) {
		super()
		assignCommonProperties(this, init)
	}
}
